import React, { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import api from "../lib/api";

export default function ScanHistory({ activeId }) {
  const [files, setFiles] = useState([]);
  const [thumbs, setThumbs] = useState({});

  useEffect(() => {
    if (!activeId) return;
    api.get("/files", { params: { household_id: activeId, kind: "kitchen" } }).then(({ data }) => setFiles(data.slice(0, 8))).catch(() => {});
  }, [activeId]);

  useEffect(() => {
    let urls = [];
    files.forEach(async (f) => {
      if (thumbs[f.id]) return;
      try {
        const res = await api.get(f.url.replace(/^\/api/, ""), { responseType: "blob" });
        const url = URL.createObjectURL(res.data); urls.push(url);
        setThumbs((t) => ({ ...t, [f.id]: url }));
      } catch { /* skip */ }
    });
    return () => urls.forEach((u) => URL.revokeObjectURL(u));
  }, [files]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!files.length) return null;
  return (
    <div className="px-6 mt-5" data-testid="scan-history">
      <p className="text-xs font-bold text-sorted-slate flex items-center gap-1 mb-2"><Camera size={12} strokeWidth={2.5} /> Recent scans</p>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {files.map((f) => (
          <div key={f.id} className="shrink-0 w-20" data-testid={`scan-thumb-${f.id}`}>
            <div className="w-20 h-20 rounded-2xl bg-white border-2 border-[#FDECEF] overflow-hidden">
              {thumbs[f.id] ? <img src={thumbs[f.id]} alt={f.location} className="w-full h-full object-cover" /> : <div className="w-full h-full animate-pulse bg-muted" />}
            </div>
            <p className="text-[10px] font-bold text-sorted-slate mt-1 capitalize truncate">{f.location} · {f.items_found ?? 0} found</p>
          </div>
        ))}
      </div>
    </div>
  );
}
